import { Box, IBoxProps } from '../Box';

export const ZStack = ({ children, ...rest }: IBoxProps) => (
  <Box {...rest} position="absolute">
    {children}
  </Box>
);
